import axios from 'axios';
import { getStore } from './storeRef';
import { setServerDown } from './uiSlice';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem('accessToken');

    if (accessToken) {
      config.headers.Authorization = `Bearer ${accessToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// A "connection failure" is either no response at all (network down, DNS,
// refused) or a gateway-level error status (backend unreachable behind the
// proxy). Those aren't normal app errors (validation, 401, 404...), so we
// surface them as a full-page "server unavailable" screen instead of raw
// axios text leaking into form/UI error states.
const isConnectionFailure = (error) => {
  if (!error.response) return true;
  return [502, 503, 504].includes(error.response.status);
};

api.interceptors.response.use(
  (response) => {
    getStore()?.dispatch(setServerDown(false));
    return response;
  },
  (error) => {
    getStore()?.dispatch(setServerDown(isConnectionFailure(error)));
    return Promise.reject(error);
  }
);

export default api;
